import { InjectionToken } from '@angular/core';

export class LayoutConfig {
  withExternalBar: boolean;
  appName: string;
  appVersion: string;
}

export const LAYOUT_CONFIG = new InjectionToken<LayoutConfig>('layout.config');
